import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Checkbox, MenuItem, TextField, Typography } from '@mui/material';
import clsx from 'clsx';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import BrandButtonView from '../../common/BrandButton';
import { DEFAULT_ACCESS_COUNTRIES, DEFAULT_ACCESS_PRODUCTS } from '../config';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Register a new agency: sub-broker registration form (demo: display and check interactions only, no validation, submit succeeds directly) */
var SubBrokerRegisterPanel = function SubBrokerRegisterPanel(props) {
  var email = props.email,
      copy = props.copy,
      submitting = props.submitting,
      onSubmit = props.onSubmit,
      onBack = props.onBack;

  var _useForm = useForm({
    defaultValues: {
      country: DEFAULT_ACCESS_COUNTRIES[0],
      entityName: '',
      contactName: '',
      phone: '',
      email: email || '',
      commissionRate: '',
      memberName: '',
      memberEmail: '',
      memberPhone: ''
    }
  }),
      control = _useForm.control;

  var _useState = useState([]),
      checkedProducts = _useState[0],
      setCheckedProducts = _useState[1];
  /**
   * methods
   */


  var toggleProductAction = function toggleProductAction(product) {
    setCheckedProducts(function (prev) {
      return prev.includes(product) ? prev.filter(function (item) {
        return item !== product;
      }) : [].concat(_toConsumableArray(prev), [product]);
    });
  };

  var addMemberAction = function addMemberAction() {// demo: clicking does not add a row, keeps the entry style only
  };

  var submitAction = function submitAction() {
    onSubmit();
  };

  var backAction = function backAction() {
    onBack();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col space-y-6",
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col items-start space-y-3",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "rounded-full bg-[var(--brand-accent)]/10 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wider text-[var(--brand-accent)]",
        children: copy === null || copy === void 0 ? void 0 : copy.label
      }), /*#__PURE__*/_jsx(Typography, {
        component: "h2",
        className: "text-2xl font-black leading-tight text-[var(--brand-primary)] md:text-[32px]",
        children: copy === null || copy === void 0 ? void 0 : copy.title
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-gray-500",
        children: copy === null || copy === void 0 ? void 0 : copy.subtitle
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row space-x-3 rounded-2xl bg-[var(--brand-accent)]/10 px-5 py-4",
      children: [/*#__PURE__*/_jsx(Box, {
        component: "svg",
        viewBox: "0 0 24 24",
        className: "mt-0.5 h-5 w-5 flex-shrink-0 fill-[var(--brand-accent)]",
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 5h2v2h-2V7zm0 4h2v6h-2v-6z"
        })
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-[var(--brand-primary)]",
        children: copy === null || copy === void 0 ? void 0 : copy.banner
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-5 rounded-2xl border border-black/10 bg-white p-6",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-sm font-extrabold text-[var(--brand-accent)]",
        children: copy === null || copy === void 0 ? void 0 : copy.entityTitle
      }), /*#__PURE__*/_jsx(Controller, {
        name: "country",
        control: control,
        render: function render(_ref) {
          var field = _ref.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            select: true,
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.countryLabel,
            children: DEFAULT_ACCESS_COUNTRIES.map(function (country) {
              return /*#__PURE__*/_jsx(MenuItem, {
                value: country,
                children: country
              }, country);
            })
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "entityName",
        control: control,
        render: function render(_ref2) {
          var field = _ref2.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.entityNameLabel
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "contactName",
        control: control,
        render: function render(_ref3) {
          var field = _ref3.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.contactNameLabel
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "phone",
        control: control,
        render: function render(_ref4) {
          var field = _ref4.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.phoneLabel
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "email",
        control: control,
        render: function render(_ref5) {
          var field = _ref5.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.emailLabel
          }));
        }
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col space-y-1",
        children: [/*#__PURE__*/_jsx(Controller, {
          name: "commissionRate",
          control: control,
          render: function render(_ref6) {
            var field = _ref6.field;
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
              fullWidth: true,
              label: copy === null || copy === void 0 ? void 0 : copy.commissionLabel
            }));
          }
        }), /*#__PURE__*/_jsx(Typography, {
          className: "text-xs text-gray-500",
          children: copy === null || copy === void 0 ? void 0 : copy.commissionHint
        })]
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-4 rounded-2xl border border-black/10 bg-white p-6",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-sm font-extrabold text-[var(--brand-accent)]",
        children: copy === null || copy === void 0 ? void 0 : copy.productTitle
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-gray-500",
        children: copy === null || copy === void 0 ? void 0 : copy.productDesc
      }), /*#__PURE__*/_jsx(Box, {
        className: "flex flex-col space-y-2",
        children: DEFAULT_ACCESS_PRODUCTS.map(function (product) {
          var checked = checkedProducts.includes(product);
          return /*#__PURE__*/_jsxs(Box, {
            className: clsx('flex cursor-pointer flex-row items-center space-x-3 rounded-xl border px-4 py-3', checked ? 'border-[var(--brand-accent)] bg-[var(--brand-accent)]/10' : 'border-black/10 bg-white'),
            onClick: function onClick() {
              return toggleProductAction(product);
            },
            children: [/*#__PURE__*/_jsx(Checkbox, {
              checked: checked,
              size: "small",
              className: "pointer-events-none p-0"
            }), /*#__PURE__*/_jsx(Typography, {
              className: "text-sm font-bold text-[var(--brand-primary)]",
              children: product
            })]
          }, product);
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-4 rounded-2xl border border-black/10 bg-white p-6",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-sm font-extrabold text-[var(--brand-accent)]",
        children: copy === null || copy === void 0 ? void 0 : copy.membersTitle
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-gray-500",
        children: copy === null || copy === void 0 ? void 0 : copy.membersDesc
      }), /*#__PURE__*/_jsxs(Box, {
        className: "grid grid-cols-1 gap-4 md:grid-cols-3",
        children: [/*#__PURE__*/_jsx(Controller, {
          name: "memberName",
          control: control,
          render: function render(_ref7) {
            var field = _ref7.field;
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
              fullWidth: true,
              label: copy === null || copy === void 0 ? void 0 : copy.memberNameLabel
            }));
          }
        }), /*#__PURE__*/_jsx(Controller, {
          name: "memberEmail",
          control: control,
          render: function render(_ref8) {
            var field = _ref8.field;
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
              fullWidth: true,
              label: copy === null || copy === void 0 ? void 0 : copy.memberEmailLabel
            }));
          }
        }), /*#__PURE__*/_jsx(Controller, {
          name: "memberPhone",
          control: control,
          render: function render(_ref9) {
            var field = _ref9.field;
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
              fullWidth: true,
              label: copy === null || copy === void 0 ? void 0 : copy.memberPhoneLabel
            }));
          }
        })]
      }), /*#__PURE__*/_jsxs(Typography, {
        className: "cursor-pointer self-start text-sm font-bold text-[var(--brand-accent)] hover:underline",
        onClick: addMemberAction,
        children: ["+ ", copy === null || copy === void 0 ? void 0 : copy.addMemberText]
      })]
    }), /*#__PURE__*/_jsx(BrandButtonView, {
      size: "large",
      className: "w-full",
      disabled: submitting,
      onClick: submitAction,
      children: copy === null || copy === void 0 ? void 0 : copy.submitText
    }), /*#__PURE__*/_jsx(Typography, {
      className: "text-center text-sm text-gray-500",
      children: copy === null || copy === void 0 ? void 0 : copy.footnote
    }), /*#__PURE__*/_jsxs(Typography, {
      className: "cursor-pointer self-center text-sm font-bold text-[var(--brand-accent)] hover:underline",
      onClick: backAction,
      children: ["\u2190 ", copy === null || copy === void 0 ? void 0 : copy.backText]
    })]
  });
};

export default SubBrokerRegisterPanel;